// Datos de ciclo escolar, caso especofico.
// Activará un caso especifico en la aplicación. En la vista de Evaluaciones, los datos se fíltrarán usando estos datos para los usuarios especificos

import { _APP_DATA } from "../../data/AppData";

// CONFIGURACIONES

interface ICicloEscolarEvaluarCaso {
    _description: string;
    _idsUsuariosAplicar: number[];
    Id: number;
    IdEscuela: number;
    Nombre: string;
    FechaInicio: string; // ISO
    FechaFin: string; // ISO
}

const fnAplicarCargo: (obj: ICicloEscolarEvaluarCaso) => boolean = (obj) => {
    if (!obj || !_APP_DATA?.userData) return false;
    const idEscuela = _APP_DATA.userData.IdKinder;
    const userId = _APP_DATA.userData.IdUsuario;
    const aplicar = obj.IdEscuela == idEscuela && obj._idsUsuariosAplicar.includes(userId);
    if (aplicar) console.debug("Aplicando caso de ciclo escolar:", _APP_DATA.userData, obj);
    return aplicar;
}

// CASOS

const caso_desarrollo: ICicloEscolarEvaluarCaso = {
    _description: "Este es un caso específico para evaluar el ciclo escolar 2024-2025",
    _idsUsuariosAplicar: [44],
    Id: 72,
    Nombre: "Primavera - Verano (2025)",
    FechaFin: "2025-08-08T06:00:00Z",
    FechaInicio: "2025-03-21T06:00:00Z",
    IdEscuela: 4,
};

const caso_produccion_agora: ICicloEscolarEvaluarCaso = {
    _description: "Caso Agora (de la organización Mimos y Agora) para evaluar el ciclo escolar 2024-2025",
    _idsUsuariosAplicar: [
        // 7727, //: msaavedramimospolanco@gmail.com
        7256, //: raucagora@gmail.com
    ],
    Id: 137,
    Nombre: "24-25",
    FechaInicio: "2024-08-01T06:00:00Z",
    FechaFin: "2025-08-31T06:00:00Z",
    IdEscuela: 102, // Agora
};

const caso_produccion_lomas: ICicloEscolarEvaluarCaso = {
    _description: "Caso Lomas para evaluar el ciclo escolar 2024-2025",
    _idsUsuariosAplicar: [
        7727, //: msaavedramimospolanco@gmail.com
        7256, //: raucagora@gmail.com
    ],
    Id: 136,
    Nombre: "24-25",
    FechaInicio: "2024-08-01T06:00:00Z",
    FechaFin: "2025-08-31T06:00:00Z",
    IdEscuela: 101, // Lomas
};


// EXPORTACIONES

const casos: ICicloEscolarEvaluarCaso[] = (import.meta.env.MODE == "production"
    ? [caso_produccion_agora, caso_produccion_lomas]
    : [caso_desarrollo]);

export const _CICLO_ESCOLAR_CASO = () => (casos.find(caso => fnAplicarCargo(caso)) || null);